import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from './../../shared/shared.module';
import { ExtractModule } from './../extract/extract.module';
import { ChartistModule } from 'ng-chartist';

import { DashboardService } from './dashboard.service';

import { DashboardComponent } from './dashboard.component';
import { RenameAccountComponent } from './rename-account/rename-account.component';
import { InvestmentComponent } from './investment/investment.component';
import { RecentReleasesComponent } from './recent-releases/recent-releases.component';
import { AccountEvolutionComponent } from './account-evolution/account-evolution.component';
import { BarCodeComponent } from './bar-code/bar-code.component';
import { AccountOptionsComponent } from './account-options/account-options.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LastTransactionsComponent } from './last-transactions/last-transactions.component';
import { MatProgressSpinnerModule, MatCardModule, MatCheckboxModule } from '@angular/material';
import { DashboardBannerCreditCardComponent } from './banner-credit-card/banner-credit-card.component';
import { FraudAwarenessBannerComponent } from './fraud-awareness-banner/fraud-awareness-banner.component';
import { FraudAwarenessBannerBottomSheetComponent } from './fraud-awareness-banner/fraud-awarenned-banner-bottom-sheet/fraud-awareness-banner-bottom-sheet.component';
import { FraudAwarenessBannerService } from './fraud-awareness-banner/fraud-awareness-banner.service';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		MatButtonModule,
		MatTableModule,
		MatInputModule,
		MatCardModule,
		MatCheckboxModule,
		ExtractModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule
	],
	declarations: [
		DashboardComponent,
		RenameAccountComponent,
		InvestmentComponent,
		RecentReleasesComponent,
		AccountEvolutionComponent,
		BarCodeComponent,
		AccountOptionsComponent,
		LastTransactionsComponent,
		DashboardBannerCreditCardComponent,
		FraudAwarenessBannerComponent,
		FraudAwarenessBannerBottomSheetComponent
	],
	entryComponents: [
		FraudAwarenessBannerBottomSheetComponent
	],
	exports: [
		DashboardComponent
	],
	providers: [DashboardService, FraudAwarenessBannerService]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/dashboard.module.ts